import { useFormContext } from '@american-autonomy/ag-ui';

import FormGrid from 'components/FormGrid';
import MultiSelectRoleField from 'components/fields/MultiSelectRoleField';

import useTranslation from './hooks/useTranslation';

import { ROLES_FIELD_NAME, TEST_ID } from './constants';
import type { FieldPath, Props, UserFormSchema } from './types';

const UserFormFields = <T extends UserFormSchema>({
    children,
    namePrefix,
    testId = TEST_ID
}: Props<T>) => {
    const { control } = useFormContext<T>();
    const { ROLES_FIELD_PLACEHOLDER } = useTranslation();

    const fieldName = (name: keyof UserFormSchema) =>
        (namePrefix ? `${namePrefix}.${String(name)}` : String(name)) as FieldPath<T>;

    return (
        <FormGrid testId={testId}>
            {children}

            <MultiSelectRoleField<T>
                control={control}
                isRequired={true}
                name={fieldName(ROLES_FIELD_NAME)}
                placeholder={ROLES_FIELD_PLACEHOLDER}
            />
        </FormGrid>
    );
};

export default UserFormFields;
